<template>
    <div class="content-wrapper">
        <!-- Page Loader -->
        <div class="vld-parent">
            <loading :active.sync="isLoading" :is-full-page="fullPage"></loading>
        </div>

        <breadcrumb :page="$t('form.invoice.editCompanyInvoice')"></breadcrumb>

        <div class="content">
            <div class="container-fluid">
                <back-button></back-button>

                <!-- <b-alert v-model="disableEditForm" variant="info">{{disableEditFormMessage}}</b-alert> -->

                 <b-alert v-model="showDisableAlert"  variant="info"> {{disableEditFormMessage}}
                    <button v-if="!firstLoad && sessionCreated" @click="checkForEdit(true)">
                         <i class="fas fa-sync"></i>
                    </button>
                </b-alert>

                <b-alert v-model="alert" :variant="alertClass" dismissible fade>{{alertMessage}}</b-alert>

                <div class="card">
                    <div class="card-header bg-light">
                        <div class="card-title">{{$t('form.invoice.editCompanyInvoice')}}</div>
                        <div class="text-right">
                            <button class="btn btn-primary" @click="invoiceUpdate()"
                                :disabled="disableEditForm ||  !permissions.editInvoicesCompanies">{{$t('button.update')}}</button>
                            <button class="btn btn-info" @click="invoiceUpdate(true)"
                                :disabled="disableEditForm ||  !permissions.editInvoicesCompanies">{{$t('button.updateClose')}}</button>
                            <button class="btn btn-danger" @click="generate('pdf')">
                                <i class="fa fa-download" aria-hidden="true"></i>{{$t('button.pdf')}}
                            </button>
                            <button class="btn btn-primary" @click="generate('word')">
                                <i class="fa fa-download" aria-hidden="true"></i>{{$t('button.word')}}
                            </button>
                        </div>
                    </div>
                    <div class="card-body">
                        <b-tabs content-class="mt-3">
                            <b-tab :title="$t('form.invoice.tabGeneral')" active>
                                <div class="form-group">
                                    <label for="InvoiceNumber">{{$t('form.invoice.invoiceNumber')}} <span
                                            class="text-danger">*</span></label>
                                    <div>
                                        <input id="InvoiceNumber" type="text" v-model="company_invoice.InvoiceNumber"
                                            class="form-control" data-role="text" name="InvoiceNumber"
                                            readonly="readonly">
                                    </div>
                                </div>

                                <div class="form-group">
                                    <label for="Student">{{$t('form.invoice.companyName')}} <span class="text-danger">*</span></label>
                                    
                                     <v-select label="CompanyName" :options="companies" v-model="company_invoice.CompanyID"
                                :reduce="companies => companies.ID"></v-select>


                                    <div class="invalid-feedback custom-validate" v-if="invalidCompany">
                                        {{$t('form.validation.required')}}
                                    </div>
                                </div>

                                <div class="form-group">
                                    <label for="InvoicePurpose">{{$t('form.invoice.invoicePurpose')}} <span
                                            class="text-danger">*</span></label>
                                    <div>
                                        <input id="InvoicePurpose"
                                            v-model.trim="$v.company_invoice.InvoicePurpose.$model"
                                            :class="{ 'is-invalid': $v.company_invoice.InvoicePurpose.$error }"
                                            name="InvoicePurpose" class="form-control">
                                        <div class="invalid-feedback"
                                            v-if="!$v.company_invoice.InvoicePurpose.required">
                                            {{$t('form.validation.required')}}</div>
                                        <div class="invalid-feedback"
                                            v-if="!$v.company_invoice.InvoicePurpose.maxLength">
                                            {{$t('form.validation.maxLength', {num: $v.company_invoice.InvoicePurpose.$params.maxLength.max})}}
                                        </div>
                                    </div>
                                </div>

                                <div class="form-group">
                                    <label for="Amount">{{$t('form.invoice.amount')}}<span
                                            class="text-danger">*</span></label>
                                    <div>
                                        <input id="Amount" v-model.trim="$v.company_invoice.Amount.$model"
                                            :class="{ 'is-invalid': $v.company_invoice.Amount.$error }" name="Amount"
                                            type="text" class="form-control">
                                        <div class="invalid-feedback" v-if="!$v.company_invoice.Amount.required">
                                            {{$t('form.validation.required')}}</div>
                                        <div class="invalid-feedback" v-if="!$v.company_invoice.Amount.decimal">
                                            {{$t('form.validation.decimalAllowed')}}</div>
                                        <div class="invalid-feedback" v-if="!$v.company_invoice.Amount.maxLength">
                                            {{$t('form.validation.maxLength', {num: $v.company_invoice.Amount.$params.maxLength.max})}}
                                        </div>
                                    </div>
                                </div>

                                <div class="form-group">
                                    <label for="Currency">{{$t('form.invoice.currency')}} <span
                                            class="text-danger">*</span></label>
                                    <div>
                                        <v-select :options="currencies"
                                            v-model.trim="$v.company_invoice.Currency.$model"
                                            :reduce="currencies => currencies" :key="company_invoice.Currency">
                                        </v-select>

                                        <div class="invalid-feedback custom-validate" v-if="invalidCurrency">
                                            {{$t('form.validation.required')}}</div>
                                    </div>
                                </div>

                                <div class="form-group">
                                    <label for="field127">{{$t('form.invoice.invoiceDate')}} <span
                                            class="text-danger">*</span></label>
                                    <date-picker :lang="lang" class="date-picker" v-model="company_invoice.InvoiceDate"
                                        valueType="format" :format="dateFormat" :popup-style="{ top: '100%', left: 0}"
                                        :append-to-body="false">
                                    </date-picker>
                                    <div class="invalid-feedback custom-validate" v-if="invalidDate">
                                        {{$t('form.validation.required')}}</div>
                                </div>

                                <div class="form-group">
                                    <label for="field125">{{$t('form.invoice.dueDate')}} <span
                                            class="text-danger">*</span></label>

                                    <date-picker :lang="lang" class="date-picker" v-model="company_invoice.DueDate"
                                        valueType="format" :format="dateFormat" :popup-style="{ top: '100%', left: 0}"
                                        :append-to-body="false">
                                    </date-picker>
                                    <div class="invalid-feedback custom-validate" v-if="invalidDue">
                                        {{$t('form.validation.required')}}</div>
                                </div>

                                <div class="form-group">
                                    <label>
                                        <input type="checkbox"  @change="changeCheck()"
                                            v-model="company_invoice.Paid" /> {{$t('form.invoice.paid')}}
                                    </label>
                                </div>

                                <div class="form-group">
                                    <label for="field126">{{$t('form.invoice.paymentDate')}}</label>
                                    <date-picker :lang="lang" class="date-picker" v-model="company_invoice.PaymentDate"
                                        valueType="format" :format="dateFormat" :popup-style="{ top: '100%', left: 0}"
                                        :append-to-body="false">
                                    </date-picker>
                                </div>

                                <div class="form-group">

                                    <label for="Status">{{$t('form.invoice.status')}} <span class="text-danger">*</span></label>
                                    <v-select @input="selectedStatus" :label="selected_status"
                                    v-model="selected_status" :options="statusArray" :reduce="statusArray => statusArray"></v-select>

                                    <div class="invalid-feedback custom-validate" v-if="invalidCompany">
                                        {{$t('form.validation.required')}}
                                    </div>
                                </div>
                            </b-tab>

                            <b-tab :title="$t('form.invoice.tabAudit')">
                                <b-table id="my-table" :items="audits" :per-page="perPageAudits" sort-by="date"
                                    :sort-desc="true" :current-page="currentPage" :fields="fields" small hover bordered
                                    responsive>
                                </b-table>

                                <b-pagination v-if="totalAudits" v-model="currentPage" :total-rows="totalAudits"
                                    :per-page="perPageAudits" aria-controls="my-table" align="center" pills>
                                </b-pagination>
                            </b-tab>
                        </b-tabs>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import {
        required,
        minLength,
        maxLength,
        decimal,
        alpha
    } from "vuelidate/lib/validators";

    export default {
        props: ['permissions', 'editFormInterval', 'dateFormat', 'datetimeFormat'],
        data() {
            return {
                alert: false,
                alertClass: '',
                alertMessage: '',
                updated: false,
                isLoading: false,
                fullPage: true,

                lang: {
                    formatLocale: {
                        firstDayOfWeek: 1,
                    },
                },
                
                request_source: '',
                invalidCurrency: false,
                invalidCompany: false,
                invalidDate: false,
                invalidDue: false,

                interval: '',
                disableEditFormMessage: '',
                disableEditForm: false,
                closing: true,


                showDisableAlert: false,
                firstLoad:true,
                sessionCreated:true,
                continueInterVal:true,


                // audits custom pagination
                currentPage: 1,
                perPageAudits: 5,
                fields: ['field', 'oldValue', 'newValue', 'userName', 'createdAt'],

                company_invoice: {
                    CompanyID: null,
                    InvoicePurpose: null,
                    InvoiceNumber: null,
                    Amount: null,
                    Currency: null,
                    InvoiceDate: moment().format(this.dateFormat),
                    DueDate: null,
                    PaymentDate: null,
                    Paid: null,
                    Status: 'Pending'
                },
                selected_status: 'Pending',

                currencies: [],
                companies: [],
                audits: [],
                availableFormats: ['pdf', 'word'],
                status:null,
                statusArray:[]
            }

        },

        validations: {
            company_invoice: {
                InvoicePurpose: {
                    required,
                    maxLength: maxLength(255)
                },
                Amount: {
                    required,
                    maxLength: maxLength(100),
                    decimal
                },
                Currency: {
                    required
                },
                InvoiceDate: {
                    required
                },
                DueDate: {
                    required
                }
            }
        },

        mounted() {
            if (!this.permissions.viewInvoicesCompanies) {
                return this.$router.push('/');
            }

            if (this.permissions.editInvoicesCompanies) {
                this.checkForEdit();
                let self = this;

                 this.interval = setInterval(() => {
                    if(self.continueInterVal)
                    self.checkForEdit();
                    }, this.editFormInterval);
            }

            this.getInitialData();
            this.getAllStatus();

        },

        computed: {
            totalAudits() {
                return this.audits.length
            }
        },

        watch: {
            company_invoice: {
                handler(val) {
                    this.closing = false;
                },
                deep: true
            }
        },

        methods: {

            async createToken(type) {
                let response = await axios.post('/api/api-tokens', {type});
                let token = '';

                if (response.status == 200) {
                    token = response.data.extra[0].token
                }

                return token;
            },

            async generate(type = null) {
                if (!this.availableFormats.includes(type)) return;

                let token = await this.createToken('student-attachment');
                if (token == '') return;

                window.open(`/invoices/${this.$route.params.id}/${type}?token=${token}`, '_blank');
            },

            selectedStatus(selected_status){
                this.company_invoice.Status = selected_status;
            },

            getAllStatus() {
                axios.get('/api/config')
                .then(response => {
                if (response.data) {
                    let config = response.data;
                    this.status = config.status;
                    if (( typeof this.status == 'object') && (this.status != '')) {
                            this.statusArray = Object.keys(this.status);
                        }
                    this.getInvoiceByID();

                    }
                })
                 .catch(error => {
                        console.log('error');
                });
            }, 

            getInitialData() {
                axios
                    .get('/api/invoices/get-initial-data')
                    .then(response => {
                        // this.company_invoice.InvoiceNumber = response.data.invoice_number;
                        // this.company_invoice.Amount = response.data.amount;
                        // this.company_invoice.Currency = response.data.default_currency;
                        // this.company_invoice.DueDate = this.getDueDate(response.data.due_date_duration);

                        this.currencies = response.data.currencies;
                        this.companies = response.data.companies;
                        this.perPageAudits = response.data.auditsPaginate;
                    })
                    .catch(error => {
                        console.log('error');
                    });
            },

            changeCheck() {
                if (this.company_invoice.Paid) {
                    this.company_invoice.PaymentDate = moment().format(this.dateFormat);
                    this.selected_status = Object.keys(this.status).find(key => this.status[key] === this.status["Paid"]);
                }else{
                    this.selected_status = Object.keys(this.status).find(key => this.status[key] === this.status[this.company_invoice.Status]);
               }
            },

            checkForEdit(refresh = false)
            {
                    if(refresh)
                    this.continueInterVal = true;
                    let data= {
                        'field_id':this.$route.params.id,
                        'form':this.$route.name,
                        'refresh':refresh,
                    }
                    // if(refresh) this.showDisableAlert = false;
                    axios
                    .post("/api/check-for-edit-session" , data)
                    .then(response => {

                        this.sessionCreated = true;
                        if (response.data.warning == 0) {

                            this.disableEditForm = false;
                            this.showDisableAlert = false;
                            if(this.firstLoad)
                            {
                                this.firstLoad = false;
                                this.getInvoiceByID();
                            }
                        }

                        if (response.data.warning == -1) {
                            this.disableEditForm = false ;
                            this.showDisableAlert = false;
                        }

                        if (response.data.warning == 1) {
                             this.firstLoad = false;
                            this.disableEditFormMessage = response.data.message;
                            this.disableEditForm = true;
                            this.showDisableAlert = true;
                            this.continueInterVal = false;
                        }

                        if (response.data.warning == 2) {
                            let msg = response.data.message;
                            if(this.firstLoad){
                              msg.replace('re-open' ,'open');
                            }
                            this.sessionCreated = false;
                            this.disableEditFormMessage = msg;
                            this.disableEditForm = true;
                            this.showDisableAlert = true;
                        }
                        if (response.data.warning == 3) {
                            this.disableEditForm = false;
                            this.showDisableAlert = true;
                            this.disableEditFormMessage = response.data.message;
                        }
                    })
                    .catch(error => {
                        console.log('error');
                    })
                },


            invoiceUpdate(shouldClose = false) {
                this.$v.$touch();

                if (this.disableEditForm) {
                    return;
                }

                if (this.company_invoice.Currency == null) {
                    this.invalidCurrency = true;
                } else {
                    this.invalidCurrency = false;
                }

                if (this.company_invoice.CompanyID == null) {
                    this.invalidCompany = true;
                } else {
                    this.invalidCompany = false;
                }

                if (this.$v.$invalid || this.invalidCompany) {
                       let errorMsg = '';

                     if(this.invalidCompany){
                        errorMsg = errorMsg ? errorMsg +", "+this.$t('form.invoice.companyName'): this.$t('form.invoice.companyName');
                    };


                    if(this.$v.company_invoice.InvoicePurpose.$error){
                        errorMsg = errorMsg ? errorMsg +", "+this.$t('form.invoice.invoicePurpose'): this.$t('form.invoice.invoicePurpose');
                    };

                    if(this.$v.company_invoice.Amount.$error){
                        errorMsg = errorMsg ? errorMsg +", "+this.$t('form.invoice.amount'): this.$t('form.invoice.amount');
                    };

                    if(this.$v.company_invoice.Currency.$error){
                        errorMsg = errorMsg ? errorMsg +", "+this.$t('form.invoice.currency'): this.$t('form.invoice.currency');
                    };

                    if(this.$v.company_invoice.InvoiceDate.$error){
                        errorMsg = errorMsg ? errorMsg +", "+this.$t('form.invoice.invoiceDate'): this.$t('form.invoice.invoiceDate');
                    };
 
                    if(this.$v.company_invoice.DueDate.$error){
                        errorMsg = errorMsg ? errorMsg +", "+this.$t('form.invoice.dueDate'): this.$t('form.invoice.dueDate');
                    };
            
                       this.showAlert(this.$t('form.validation.mandatoryFieldsError', {errors:errorMsg}), 'danger');
                    return;

                } else {
                    this.isLoading = true;
                    this.closing = true;
                    if (this.selected_status)
                    this.company_invoice.Status = this.selected_status;

                    let data = {
                        ...this.company_invoice
                    };

                    if (data.InvoiceDate)
                        data.InvoiceDate = moment(data.InvoiceDate, this.dateFormat).format('YYYY-MM-DD');

                    if (data.DueDate)
                        data.DueDate = moment(data.DueDate, this.dateFormat).format('YYYY-MM-DD');

                    if (data.PaymentDate)
                        data.PaymentDate = moment(data.PaymentDate, this.dateFormat).format('YYYY-MM-DD');

                  

                    axios
                        .put('/api/companyinvoices/' + this.$route.params.id, data)
                        .then(response => {
                            this.isLoading = false;
                            this.updated= true;
                            if (response.data.success) {

                                this.showAlert(response.data.message);
                                if (shouldClose) {
                                        clearInterval(this.interval);
                                        setTimeout(() => this.$router.go(-1), 2000);
                                        return;
                                    }
                            }

                            if (response.data.error) {
                                this.isLoading = false;
                                this.showAlert(response.data.message, 'danger');
                            }

                        }, error => {
                            this.isLoading = false;
                            console.log('error');
                        });

                }
            },

            getInvoiceByID() {
                this.isLoading = true;

                axios
                    .get('/api/companyinvoices/' + this.$route.params.id + '/edit')
                    .then(response => {
                        // this.company_invoice = response.data.invoice;
                        this.company_invoice.CompanyID = response.data.invoice.company[0].ID;
                        this.company_invoice.InvoicePurpose = response.data.invoice.InvoicePurpose;
                        this.company_invoice.InvoiceNumber = response.data.invoice.InvoiceNumber;
                        if(this.status){
                        this.company_invoice.Status = this.company_invoice.Status ? this.company_invoice.Status : 1;
                        this.selected_status = Object.keys(this.status).find(key => this.status[key] === response.data.invoice.Status);
                        }
                        this.company_invoice.Amount = response.data.invoice.Amount;
                        this.company_invoice.Currency = response.data.invoice.Currency;
                        this.company_invoice.InvoiceDate = response.data.invoice.InvoiceDate;
                        this.company_invoice.DueDate = response.data.invoice.DueDate;
                        this.company_invoice.PaymentDate = response.data.invoice.PaymentDate;
                        this.company_invoice.Paid = response.data.invoice.Paid;

                        if (this.company_invoice.InvoiceDate) {
                            this.company_invoice.InvoiceDate = moment(this.company_invoice.InvoiceDate).format(this
                                .dateFormat);
                        }

                        if (this.company_invoice.DueDate) {
                            this.company_invoice.DueDate = moment(this.company_invoice.DueDate).format(this
                                .dateFormat);
                        }

                        if (this.company_invoice.PaymentDate) {
                            this.company_invoice.PaymentDate = moment(this.company_invoice.PaymentDate).format(this
                                .dateFormat);
                        }

                        this.audits = response.data.audits;

                        this.audits.map(audit => {
                            audit.date = audit.createdAt;
                            audit.createdAt = moment(audit.createdAt).format(this.datetimeFormat);
                        });

                        setTimeout(() => {
                            this.isLoading = false;
                            this.closing = true;
                        }, 2000);
                    })
                    .catch(error => {
                        console.log(error);
                    });
            },

            getDueDate(days, format = 'YYYY-MM-DD') {
                days = parseInt(days);
                return moment().add(days, 'days').format(format);
            },

            showAlert(msg, cls = 'success') {
                this.alertMessage = msg;
                this.alertClass = cls;
                this.alert = true;
            }
        },

        beforeRouteLeave(to, from, next) {
            clearInterval(this.interval);

            if (this.closing || this.updated) next()
            else {
                const answer = window.confirm(this.$t('leavePrompt'))

                if (answer) {
                    next()
                } else {
                    next(false)
                   }
            }
        }
    }

</script>
<style scoped>
    .custom-validate {
        display: block !important;
    }

</style>
